import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { OrdenesService } from './services/ordenes.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'tulioos-dev';
  ordenes: Observable<any>;

  constructor(private ordenesService: OrdenesService,) {
  }


}
